<template>
  <div class="mic-com coupon">
    <div class="coupon-list" v-if="list.length||loaded">
      <div class="coupon-item coupon-purple coupon-item_large" v-if="list.length===1">
        <div class="coupon-panel">
          <p class="coupon-value">{{list[0].value.substr(0,list[0].value.length-1)}}<span>{{list[0].value.substr(list[0].value.length-1,1)}}</span></p>
          <div class="coupon-text">
            <p>{{list[0].type}}</p>
            <p>{{list[0].limit}}</p>
          </div>
        </div>
        <div class="get-now" @click="getCoupon(list[0])">立即领取</div>
      </div>
      <div class="coupon-item" :class="getCls(index)" v-for="(item,index) in list" :key="item.key" v-else @click="getCoupon(item)">
        <p class="coupon-value">{{item.value.substr(0,item.value.length-1)}}<span>{{item.value.substr(item.value.length-1,1)}}</span></p>
        <p>{{item.limit}}</p>
      </div>
    </div>
    <div class="empty" v-else>
      <p>请选择优惠券</p>
    </div>
  </div>
</template>

<script>
  import Common from '../mixins/Common';
  import * as API from '@/api/shop';
  import CouponParser from '@/utils/CouponParser';

  // /Coupon/CouponDetail /api/Shop/GetCoupon

  function isSame(A, B) {
	if (typeof A !== typeof B) return false;
	if (typeof A === 'object') return JSON.stringify(A) === JSON.stringify(B);
	return A === B;
  }

  export default {
	name: 'Coupon',
	props: {},
	mixins: [Common,],
	components: {},
	data() {
	  return {
		list: [],
		loaded: false,
		observerKeys: [
		  'config.coupon_guids',
		],
	  };
	},
	created() {
	  this.getList();
	  if (!this.preview) return;
	  this.$watch('config.coupon_guids', (now, old) => {
		if (isSame(now, old)) return;
		this.getList();
	  });
	},
	methods: {
	  getCls(index) {
		let cls = this.list.length === 2 ? 'coupon-item_big' : 'coupon-item_small';
		return 'coupon-' + ['blue', 'red', 'purple'][index % 3] + ' ' + cls;
	  },
	  async getList() {
		const guids = this.config.coupon_guids;
		if (!guids.length) return;
		const result = await API.getCouponList({guids});
		this.loaded = true;
		if (!result.success) return;
		this.list = result.data.list.map(it => new CouponParser(it));
	  },
	  async getCoupon(item) {
		console.log('item---', item);
		if (this.$IS_PREVIEW) return;
		const {bid} = this.$utils.param2Obj();
		if (this.$platform && !this.$platform.isMember) {
		  window.location.href = this.$platform.registerHref;
		  return;
		}
		if (item.online_get_way) {
		  window.location.href = `/Coupon/CouponDetail?guid=${item.guid}&bid=${bid}`;
		  return;
		}
		const result = await API.getCoupon({guid: item.guid});
		if (!result.success) return;
		this.$toast.success('领取成功!');
	  }
	},
  };
</script>

<style lang="less" rel="stylesheet/less">

  .coupon {
    overflow: hidden;

    .empty {
      p {
        text-align: center;
        line-height: 50px;
      }
    }

    .coupon-list {
      background-color: #fff;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 10px 0;
      white-space: nowrap;
      font-size: 0;

      &::-webkit-scrollbar {
        display: none;
      }

      .coupon-item {
        font-size: 14px;
        margin: 0 10px;
        height: 80px;
        border-radius: 6px;
        color: #fff;

        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;

        &:before {
          left: 0;
          transform: translate(-50%);
        }

        &:after {
          transform: translate(50%);
          right: 0;
        }

        &:before, &:after {
          content: "";
          position: absolute;
          bottom: 5px;
          top: 5px;
          background-image: radial-gradient(circle at center, #fff 0, #fff 5px, transparent 5px);
          background-size: 18px 18px;
          width: 18px;
        }

        .coupon-value {
          font-size: 28px;
          margin-bottom: 8px;

          span {
            font-size: 16px;
          }
        }

        &.coupon-item_small {
          width: 130px;
        }

        &.coupon-item_big {
          width: 165px;
        }

        &.coupon-item_large {
          flex-direction: row;
          width: calc(100% - 20px);
        }
      }

      .coupon-panel {
        display: flex;
        flex: 1;
        align-items: center;
        padding-left: 30px;

        .coupon-value {
          margin-right: 10px;
        }

        .coupon-text {
          font-size: 14px;
        }
      }

      .get-now {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        border-left: 1px dashed #fff;
        position: relative;

        &:after, &:before {
          content: '';
          position: absolute;
          left: -5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #fff;
        }

        &:after {
          bottom: -15px;
        }

        &:before {
          top: -15px;
        }
      }

      .coupon-red {
        background-image: linear-gradient(to right, #FE7636, #FF5A3A);
      }

      .coupon-blue {
        background-image: linear-gradient(to right, #0AB4FE, #0199FE);
      }

      .coupon-purple {
        background-image: linear-gradient(to right, #8A8BFA, #776DF6);
      }
    }
  }
</style>
